export default __webpack_public_path__ + "static/media/icon_labs.8c9a4e65.svg";